// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoForfeitureSummaryRecordDto } from './IReportSummaryGroupDtoForfeitureSummaryRecordDto';
import {
    IReportSummaryGroupDtoForfeitureSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoForfeitureSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoForfeitureSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoForfeitureSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoForfeitureSummaryRecordDto';
import type { IForfeitureSummaryRecordDto } from './IForfeitureSummaryRecordDto';
import {
    IForfeitureSummaryRecordDtoFromJSON,
    IForfeitureSummaryRecordDtoFromJSONTyped,
    IForfeitureSummaryRecordDtoToJSON,
    IForfeitureSummaryRecordDtoToJSONTyped,
} from './IForfeitureSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoForfeitureSummaryRecordDto
 */
export interface IReportSummaryDtoForfeitureSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoForfeitureSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IForfeitureSummaryRecordDto>}
     * @memberof IReportSummaryDtoForfeitureSummaryRecordDto
     */
    employer_records?: Array<IForfeitureSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoForfeitureSummaryRecordDto>}
     * @memberof IReportSummaryDtoForfeitureSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoForfeitureSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoForfeitureSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoForfeitureSummaryRecordDto(value: object): value is IReportSummaryDtoForfeitureSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoForfeitureSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoForfeitureSummaryRecordDto {
    return IReportSummaryDtoForfeitureSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoForfeitureSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoForfeitureSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IForfeitureSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoForfeitureSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoForfeitureSummaryRecordDtoToJSON(json: any): IReportSummaryDtoForfeitureSummaryRecordDto {
    return IReportSummaryDtoForfeitureSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoForfeitureSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoForfeitureSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IForfeitureSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoForfeitureSummaryRecordDtoToJSON)),
    };
}

